"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var checkFontsExist = function checkFontsExist() {
  var fontId = "ryerson_font_stylesheet";

  if (typeof document !== "undefined" && !document.getElementById(fontId)) {
    var link = document.createElement("link");
    link.id = fontId;
    link.rel = "stylesheet";
    link.href = "/static-assets/fonts/fonts.css";
    document.head.appendChild(link);
  }
};

exports.default = checkFontsExist;